import { SELECT_FACILITY, GET_MY_FACILITIES } from "../actions/types";

const selectedFacility = JSON.parse(localStorage.getItem("selectedFacility"));

const initialState = {
  selectedFacility,
  myfacilities: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_MY_FACILITIES:
      const { myfacilities } = payload;
      return {
        ...state,
        myfacilities,
      };

    case SELECT_FACILITY:
      const { selectedFacility } = payload;
      return {
        ...state,
        selectedFacility,
      };
    default:
      return state;
  }
}
